import { AppProvider } from '@!/providers'
import { useAppSettings } from '@!/Hooks/useAppSettings'
import MonthlyCourseHistories from '@!/User/MonthlyCourseHistories/containers/MonthlyCourseHistories'

const MonthlyCourseHistoriesApp = (props) => {
  const jotaiStore = useAppSettings({ isSaveLastUrl: true, alertMessage: props.alert_message })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <MonthlyCourseHistories histories={props.histories} />
    </AppProvider>
  )
}

export default MonthlyCourseHistoriesApp
